import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/edi/shippinginstructionrequest'
import pathMap from 'src/paths/PathMap_EDI'

class ShippingInstructionRequestRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.SHIPPING_INSTRUCTION_REQUEST_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.SHIPPING_INSTRUCTION_REQUEST_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.SHIPPING_INSTRUCTION_REQUEST_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.SHIPPING_INSTRUCTION_REQUEST_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default ShippingInstructionRequestRoute
